import Page500 from "./Page500";

export { Page500 };
